"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WholesaleShipmentStatus = void 0;
exports.WholesaleShipmentStatus = {
    Error: "ERROR",
    Draft: "DRAFT",
    Submitted: "SUBMITTED",
    PickingStarted: "PICKING_STARTED",
    InTransit: "IN_TRANSIT",
    ReadyToShip: "READY_TO_SHIP",
    FreightOrdered: "FREIGHT_ORDERED",
    Shipped: "SHIPPED",
    Delivered: "DELIVERED",
    Cancelled: "CANCELLED",
    Scheduled: "SCHEDULED",
};
//# sourceMappingURL=wholesale-shipment-status.js.map